<template>
    <div id="how-it-works">
        <section class="how-it-works-section mb-5">
            <div class="container text-center">
                <div class="row justify-content-center">
                    <div class="col">
                        <h1 class="section-title mb-5">How it works</h1>
                    </div>
                </div>
                <div id="step-one" data-aos="fade-right" data-aos-duration="800">
                    <div class="row justify-content-center mb-4">
                        <div class="col-lg col-md-12 order-lg-last pr-lg-0 pl-lg-0">
                            <div class="h-100 d-lg-flex justify-content-center flex-column text-lg-left text-md-center">
                                <div class="container pr-lg-0 pl-lg-0">
                                    <div class="row">
                                        <div class="col-lg-2 col-12 pr-lg-0 pl-lg-0">
                                            <h1 class="w-100 text-lg-center text-center go-over-left float-lg-right float-none font-weight-light">
                                                01</h1>
                                        </div>
                                        <div class="col-lg col-12 pt-3">
                                            <h5 class="text-lg-left text-center">Apply to SPIRITT</h5>
                                            <p class="text-lg-left text-center steps-p">The application form's purpose is to check whether there is a fit between your idea and our service; We work only with start-ups that get the most out of our service (we love happy clients).</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-lg col-12 pr-lg-0 pl-lg-0">
                            <img data-aos="fade-up"
                                 data-aos-duration="1200"  class="mx-auto img-fluid" alt="Apply to Spiritt.io"
                                 src="img/saas/how-it-works/step1.svg">
                        </div>
                    </div>
                </div >
                <div id="step-two" data-aos="fade-left" data-aos-duration="800">
                    <div class="row justify-content-center mb-4">
                        <div class="col-lg col-12 pr-lg-0 pl-lg-0 margin-top-130-px">
                            <div class="h-100 d-lg-flex justify-content-center flex-column text-lg-left text-md-center">
                                <div class="container pr-lg-0 pl-lg-0">
                                    <div class="row">
                                        <div class="col-lg-2 col-12 order-lg-last pr-lg-0 pl-lg-0">
                                            <h1 class="w-100 text-lg-center text-md-center go-over-right font-weight-light">02</h1>
                                        </div>
                                        <div class="col-lg col-12 pr-lg-0 pl-lg-0pt-3">
                                            <h5 class="text-lg-right text-center">YOU'RE IN, Congratulations!</h5>
                                            <p class="text-lg-right text-center steps-p float-lg-right float-none">
                                                Our devoted team of humans, with a little help of smart algorithms, checked your application and found your start-up a fit! You got accepted - it's probably meant to be.</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div data-aos="fade-up"
                             data-aos-duration="1200" class="col-lg col-12 order-lg-last pr-lg-0 pl-lg-0">
                            <img class="zxc mx-auto img-fluid" alt="YOU'RE IN, Congratulation!"
                                 src="img/saas/how-it-works/step2.svg">
                        </div>
                    </div>
                </div>
                <div id="step-three" data-aos="fade-right" data-aos-duration="800">
                    <div class="row justify-content-center mb-4">
                        <div class="col-lg col-md-12 order-lg-last pr-lg-0 pl-lg-0 margin-top-100-px">
                            <div class="h-100 d-lg-flex justify-content-center flex-column text-lg-left text-md-center">
                                <div class="container pr-lg-0 pl-lg-0">
                                    <div class="row">
                                        <div class="col-lg-2 col-12 pr-lg-0 pl-lg-0">
                                            <h1 class="w-100 text-lg-center text-center go-over-left float-lg-right float-none font-weight-light">
                                                03</h1>
                                        </div>
                                        <div class="col-lg col-12 pt-3">
                                            <h5 class="text-lg-left text-center">Create Without Coding or Designing</h5>
                                            <p class="text-lg-left text-center steps-p float-lg-left float-none">
                                              Describe your style preferences and your app's features and functionality using our smart system - It is extremely easy, and you don't need any tech skills or learning curve. Seriously.</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div data-aos="fade-up"
                             data-aos-duration="1200" class="col-lg col-12 pr-lg-0 pl-lg-0">
                            <img class="mx-auto img-fluid" alt="building without coding & designing"
                                 src="img/saas/how-it-works/step3.svg">
                        </div>
                    </div>
                </div>
                <div id="step-four" data-aos="fade-left" data-aos-duration="800">
                    <div class="row justify-content-center mb-4">
                        <div class="col-lg col-12 pr-lg-0 pl-lg-0 margin-top-130-px">
                            <div class="h-100 d-lg-flex justify-content-center flex-column text-lg-left text-md-center">
                                <div class="container pr-lg-0 pl-lg-0">
                                    <div class="row">
                                        <div class="col-lg-2 col-12 order-lg-last pr-lg-0 pl-lg-0">
                                            <h1 class="w-100 text-lg-center text-md-center go-over-right float-lg-left float-none font-weight-light">
                                                04</h1>
                                        </div>
                                        <div class="col-lg col-12 pr-lg-0 pl-lg-0pt-3">
                                            <h5 class="noto-sans-kr text-lg-right text-center">Track Your Product Creation</h5>
                                            <p class="noto-sans-font-title text-lg-right text-center steps-p float-lg-right float-none">
                                              A combination of human professionals with an AI will work together to take your idea to the highest execution level. We want every application to be outstanding because it promotes us as well as you. </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-lg col-12 order-lg-last pr-lg-0 pl-lg-0">
                            <img data-aos="fade-up"
                                 data-aos-duration="1200" class="mx-auto img-fluid steps-img-md" alt="Track Your Product Creation"
                                 src="img/saas/how-it-works/step4.svg">
                        </div>
                    </div>
                </div>
                <div id="step-five" data-aos="fade-right" data-aos-duration="800">
                    <div class="row justify-content-center mb-4">
                        <div class="col-lg col-md-12 order-lg-last pr-lg-0 pl-lg-0">
                            <div class="h-100 d-lg-flex justify-content-center flex-column text-lg-left text-md-center">
                                <div class="container pr-lg-0 pl-lg-0">
                                    <div class="row">
                                        <div class="col-lg-2 col-12 pr-lg-0 pl-lg-0">
                                            <h1 class="w-100 text-lg-center text-center go-over-left float-lg-right float-none font-weight-light">
                                                05</h1>
                                        </div>
                                        <div class="col-lg col-12 pt-3">
                                            <h5 class="noto-sans-kr text-lg-left text-center">Done. Enjoy Your Free 7 Days</h5>
                                            <p class="noto-sans-font-title text-lg-left text-center steps-p">
                                                Your free 7 days trial includes a beautiful, hosted, published, and ready to use application! Enjoy.
                                                Now it is your time to get as many users and revenue as you can.
                                                Note that you can customize and change your app by yourself from your dashboard at any time - no extra fee.</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div data-aos="fade-up"
                             data-aos-duration="1200" class="col-lg col-12 pr-lg-0 pl-lg-0">
                            <img class="mx-auto img-fluid steps-img-md" alt="Done. Enjoy Your 7 Days Free"
                                 src="img/saas/how-it-works/step5.svg">
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </div>
</template>

<script>
  export default {
    name: 'how-it-works',
  }
</script>

<style lang="css" scoped>
    #how-it-works {
        background-color: #fff;
        overflow: hidden;
        content: "";
        -webkit-box-align: center;
        -ms-flex-align: center;
        align-items: center;
        position: relative;
        color: #000000;
        min-height: 100vh;
        width: 100%;
        display: flex;
        justify-content: center;
        flex-direction: column;
    }
    .how-it-works-section {
        padding-top: 80px;
        padding-bottom: 40px;
    }
    .section-title {
        font-size: 45px;
        font-weight: 300;
        line-height: 1;
    }
    @media (max-width: 767px) {
        .how-it-works-section {
            padding-bottom: 0;
        }
    }
    .left-border {
        border-left: 1px solid #000000;
        height: 46px;
    }
    .go-over-left {
        left: calc(15px - 50%);
        position: absolute;
    }
    .steps-p {
        padding-bottom: 0;
        min-height: 84px;
    }
    .right-border {
        border-right: 1px solid #000000;
        height: 46px;
    }
    .go-over-right {
        right: calc(15px - 50%);
        position: absolute;
    }
    @media (max-width: 991px) {
        .left-border, .right-border {
            border-width: 2px;
            height: 76px;
            margin-left: 0;
            margin-right: 0;
            margin-bottom: 60px;
        }
        .go-over-right, .go-over-left {
            margin-right: 0 !important;
            margin-left: 0 !important;
            left: 0;
            right: 0;
            position: relative;
        }
    }
    @media (min-width: 992px){
        .margin-top-100-px {
            margin-top: 100px
        }

        .margin-top-130-px {
            margin-top: 130px
        }
        .mw-280-px {
            max-width: 280px;
            margin: auto;
        }
        .mw-450-px {
            max-width: 450px;
            margin: auto;
        }
        .margin-top-100-px-desktop {
            margin-top: 100px
        }
    }

    @media (max-width: 991px){
        .margin-top-100-px {
            margin-top: 50px
        }

        .margin-top-130-px {
            margin-top: 65px
        }
    }
    @media (min-width: 992px) {
        .order-lg-last {
            -webkit-box-ordinal-group: 14;
            -ms-flex-order: 13;
            order: 13;
        }
    }
</style>
